import templateUrl from "servicestack/sort-options.htm";

export default {
  bindings: {
    db: "<ngModel",
    size: "@",
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
